import { FC, useState } from 'react';
import {
  Box,
  Card,
  Typography,
  Collapse,
  ListItem,
  ListItemIcon,
} from '@mui/material';
import {
  ExpandLess,
  ExpandMore,
  InfoOutlined,
  PeopleOutlined,
  Warning,
} from '@mui/icons-material';
import { IconType } from '../../enums/IconType';
import { useInfoCardStyles } from './useInfoCardStyles';

type Props = {
  comment: string;
  icon: IconType;
};

export const InfoCardContent: FC<Props> = ({ comment, icon }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen((prev) => !prev);

  const truncateLength = 28;
  const showToggle = comment.length > truncateLength;

  const truncate = (comment: string, n: number) => {
    return comment.length > n ? comment.substr(0, n - 1) + '...' : comment;
  };

  const classes = useInfoCardStyles();
  return (
    <Box sx={classes.heading} py={1}>
      <ListItem
        button={showToggle as any}
        dense
        sx={showToggle ? classes.headerSpace : classes.headerStart}
        onClick={toggleOpen}
      >
        {icon === IconType.People && (
          <PeopleOutlined fontSize="large" sx={classes.icon} />
        )}
        {icon === IconType.Info && (
          <InfoOutlined fontSize="large" sx={classes.icon} />
        )}
        {icon === IconType.Warning && (
          <Warning fontSize="large" sx={classes.icon} />
        )}

        <Box px={1}>
          <Typography variant="subtitle1">
            {truncate(comment, truncateLength)}
          </Typography>
        </Box>

        {showToggle && (
          <ListItemIcon>{open ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
        )}
      </ListItem>
      {comment.length > truncateLength && (
        <Collapse in={open}>
          <Box px={2} py={1}>
            {comment}
          </Box>
        </Collapse>
      )}
    </Box>
  );
};

export const InfoCard: FC = ({ children }) => {
  const classes = useInfoCardStyles();
  return (
    <Card sx={classes.card}>
      <Box>{children}</Box>
    </Card>
  );
};
